import { render, staticRenderFns } from "./SettupCourse.vue?vue&type=template&id=5b24ea4d&scoped=true"
import script from "./SettupCourse.vue?vue&type=script&lang=js"
export * from "./SettupCourse.vue?vue&type=script&lang=js"
import style0 from "./SettupCourse.vue?vue&type=style&index=0&id=5b24ea4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b24ea4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
